export default "__VITE_ASSET__CFNntjgQ__"